<div class="facial-recognition-image-uploader">
  <fgb-facial-recognition-uploader-header
    facialRecognitionHeading="{{ 'facial.recognition.review.photo.failed.heading' | translate }}"
    facialRecognitionSubheading="{{ 'facial.recognition.review.photo.failed.subheading' | translate }}"
    [stepCounter]="stepCounter"
    [showCloseButton]="true"
    (setStep)="setStep.emit($event)"
    (previousStepChange)="previousStepChange.emit()"
  ></fgb-facial-recognition-uploader-header>

  <div class="container facial-recognition-details-div mt-3 text-center">
    <div class="border facial-recognition-photo-div mb-2">
      <div class="border facial-recognition-photo-div mb-2">
        <img
          *ngIf="imageSrc || uploadedImage.value"
          [src]="uploadedImage.value || imageSrc"
          width="100%"
          height="100%"
          alt="facial recognition"
        />
      </div>
    </div>
    <div class="font-size-14 review-photo-failed-details-heading text-danger">
      {{ 'facial.recognition.review.photo.failed.details.heading' | translate }}
    </div>
    <div class="font-size-14 review-photo-failed-details-subheading">
      {{ 'facial.recognition.review.photo.failed.details' | translate }}
    </div>
    <fgbcl-errors></fgbcl-errors>
  </div>

  <div class="container facial-recognition-buttons-div">
    <fgb-facial-recognition-uploader-button
      [facialRecognitionButtonType]="4"
      (retakePhoto)="retakePhoto()"
    ></fgb-facial-recognition-uploader-button>
    <div class="d-lg-none d-flex align-items-center justify-content-center">
      <hr />
      <span class="mx-3 font-size-14">{{ 'facial.recognition.photo.info.or' | translate }}</span>
      <hr />
    </div>
    <fgb-facial-recognition-uploader-button
      [uploadedImage]="uploadedImage"
      [formData]="formData"
      [facialRecognitionButtonType]="2"
      [smallUploadButton]="true"
      (uploadedImageEvent)="uploadedImageChange()"
    ></fgb-facial-recognition-uploader-button>
  </div>
</div>
